import { Configuration, PublicClientApplication } from '@azure/msal-browser';

// Client ID comes from .env (REACT_APP_MS_CLIENT_ID). If it's not set,
// Outlook login is skipped in the UI and every other login path is
// unaffected.
export const msClientId = process.env.REACT_APP_MS_CLIENT_ID || '';
export const outlookLoginEnabled = Boolean(msClientId);

const msalConfig: Configuration = {
    auth: {
        clientId: msClientId || '00000000-0000-0000-0000-000000000000',
        // 'common' allows both personal Microsoft accounts (Outlook.com/Hotmail)
        // and work/school (Azure AD) accounts to sign in.
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
};

// Single shared MSAL instance used by MsalProvider in index.tsx and by the
// Outlook login button in Login.tsx.
export const msalInstance = new PublicClientApplication(msalConfig);

export const msLoginRequest = {
    scopes: ['User.Read'],
    // Forces the account-chooser screen every time, instead of silently
    // reusing a Microsoft account already signed in on this browser
    // (matches the "choose an account" behavior Google's button gives you).
    prompt: 'select_account',
};